module.exports = __webpack_public_path__ + "static/media/NanumSquareR.05c46ab6.ttf";